import Vue from 'vue'

// 自定义指令使弹窗可拖动
Vue.directive('drag-modal', (el, bindings, vnode) => {
  Vue.nextTick().then(() => {
    // 获取组件实例中的属性
    const componentInstance = vnode.componentInstance
    const { visible, destroyOnClose } = componentInstance || {}

    if (!visible) return

    // 获取模态框和头部元素
    const modal = el.getElementsByClassName('ivu-modal-content')[0]
    const header = el.getElementsByClassName('ivu-modal-header')[0]

    if (!header || !modal) return

    header.style.cursor = 'move' // 设置鼠标样式为可移动

    // 存储上一次的偏移位置
    let left = 0
    let top = 0

    // 如果未设置 destroyOnClose，则 DOM 未被销毁，需要保留上次的位置
    if (!destroyOnClose) {
      left = modal.left || 0
      top = modal.top || 0
    }

    // 初始 top 值为 offsetTop
    if (typeof modal.left !== 'number') {
      top = top || modal.offsetTop
    }

    // 鼠标按下事件
    header.onmousedown = function (e) {
      const startX = e.clientX
      const startY = e.clientY

      // 鼠标移动事件
      el.onmousemove = function (event) {
        const endX = event.clientX
        const endY = event.clientY

        modal.left = endX - startX + left
        modal.top = endY - startY + top

        modal.style.left = modal.left + 'px'
        modal.style.top = modal.top + 'px'
      }

      // 鼠标松开事件
      el.onmouseup = function () {
        left = modal.left
        top = modal.top

        el.onmousemove = null
        el.onmouseup = null

        // 兼容性处理：释放捕获
        if (header.releaseCapture) {
          header.releaseCapture()
        }
      }

      // 捕获鼠标事件（IE兼容）
      if (header.setCapture) {
        header.setCapture()
      }
    }
  })
})



// WEBPACK FOOTER //
// ./src/directive/drag-modal.js